import { useState, useRef, useEffect } from "react"
import { Typography } from "@stardust-ds/react"
import intl from "react-intl-universal"

import styles from "./index.module.scss"
import DownArrow from "../../../assets/icons/DownArrow"
import useClickOutside from "../../../hooks/useClickOutside"

export default function FilterSelect(props) {
  const { data, onChange, selected, disabled } = props

  const [select, setSelect] = useState()
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    const getSelectedLabel = selected ? data?.find(d => d?.value === selected)?.label : intl.get("order")
    setSelect(getSelectedLabel)
  }, [select])

  const containerRef = useRef(null)
  useClickOutside(containerRef, () => setIsOpen(false));

  if (!data?.length) return null

  const handelValue = (data) => {
    setSelect(data.label)
    onChange?.(data?.value);
  }

  const Options = () => {
    return (
      <div className={styles.options}>
        {data.map((option, i) => {
          return (
            <div
              className={styles.option}
              onClick={() => handelValue(option)}
              key={i}
            >
              {option.icon}
              <Typography type="p1">{option.label}</Typography>
            </div>
          )
        })}
      </div>
    )
  }

  return (
    <div
      ref={containerRef}
      className={!disabled ? styles.selectContainer : styles.selectContainerDisabled}
      onClick={() => !disabled && setIsOpen((e) => !e)}
    >
      <div className={styles.selectContent}>
        <Typography textAlign="center" type="p1">
          {select}
        </Typography>
        <div className={styles.arrowContainer}>
          <DownArrow
            fill="#FFFFFF"
            style={{
              transform: isOpen && "rotate(-180deg)",
              transition: "all .2s",
            }}
          />
        </div>
      </div>
      {isOpen && <Options />}
    </div>
  )
}
